(function () {
    'use strict';

    function CompanyCustomerComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, CompanyCustomerCustom, $mdDialog, DialogService, CustomerGroupCustom, UserCustom, CustomerCustom) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';

        $ctrl.loadAll = loadAll;

        $ctrl.getCompanyCustomerFormDataFunc = getCompanyCustomerFormDataFunc;
        $ctrl.editCompanyCustomerFormDataFunc = editCompanyCustomerFormDataFunc;
        $ctrl.customerFormData = null;
        $ctrl.columnCount = null;
        $ctrl.companyCustomer.singleRecordForms = [];
        $ctrl.companyCustomer.multiRecordForms = [];

        $ctrl.companyCustomer.singleRecordFormDatas = [];
        $ctrl.companyCustomer.multiRecordFormDatas = [];

        $ctrl.deleteCustomerFormData = deleteCustomerFormData;
        $ctrl.customerGroupChanged = customerGroupChanged;
        $ctrl.customerStatuses = ["NEW_CUSTOMER", "VALID_CUSTOMER", "BLOCKED_CUSTOMER"];

        $ctrl.reserveHistorySearchQuery = null;

        $ctrl.createUser = createUser;
        $ctrl.user = {};
        $ctrl.hasUser = false;
        $ctrl.existUser = {};


        loadAll();
        loadPage();

        function loadAll() {
            $ctrl.companyCustomer.singleRecordForms = [];
            $ctrl.companyCustomer.multiRecordForms = [];
            // $ctrl.companyCustomer.forms = [];

            if ($ctrl.companyCustomer && $ctrl.companyCustomer.id) {
                $ctrl.companyCustomer.forms = CompanyCustomerCustom.getCompanyCustomForm($ctrl.companyCustomer.companyId).query(function (forms) {
                    angular.forEach(forms, function (item) {
                        if (item.recordType && item.recordType == 'SINGLE_RECORD') {
                            $ctrl.companyCustomer.singleRecordForms.push(item);
                        } else {
                            $ctrl.companyCustomer.multiRecordForms.push(item);
                        }

                    })


                });

                CompanyCustomerCustom.getCompanyCustomFormDataByCompanyCustomerId($ctrl.companyCustomer.id).query().$promise.then(function (res) {


                    $ctrl.companyCustomer.singleRecordFormDatas = [];
                    $ctrl.companyCustomer.multiRecordFormDatas = [];
                    $ctrl.companyCustomer.formsData = res;
                    $ctrl.companyCustomer.formsData.sort(function (a, b) { //to sort by id desc
                        return b.id - a.id;
                    });

                    angular.forEach($ctrl.companyCustomer.formsData, function (item) {

                        if (item.companyCustomForm.recordType == 'SINGLE_RECORD') {
                            $ctrl.companyCustomer.singleRecordFormDatas.push(item);
                            removeSingleRecordButton(item.companyCustomForm);
                        } else {
                            $ctrl.companyCustomer.multiRecordFormDatas.push(item);
                        }

                    })

                });
            }

            loadAllCustomerGroups();
            if (!$ctrl.companyCustomer.id) {
                initNewCustomerIntakeData();
            }

            // has user
            if ($ctrl.companyCustomer.id && $ctrl.companyCustomer.customer.id) {
                CustomerCustom.getCustomerUserInfoByCustomerId($ctrl.companyCustomer.customer.id).query().$promise.then(function (res) {
                        $ctrl.existUser = res;
                        if ($ctrl.existUser.id)
                            $ctrl.hasUser = true;
                        else
                            $ctrl.hasUser = false;
                    }
                )
            }

        }


        function removeSingleRecordButton(companyCustomForm) {

            $ctrl.companyCustomer.singleRecordForms = $ctrl.companyCustomer.singleRecordForms.filter(function (item) {
                return item.id != companyCustomForm.id;
            })
        }

        function loadPage() {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader.addPart('customerStatus');
            translatePartialLoader = translate.refresh();
        }


        function getCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle) {


            CompanyCustomerCustom.getNewCompanyCustomerFormData(companyCustomFormId).query(function (res) {

                $ctrl.customerFormData = res;
                $ctrl.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
                $ctrl.customerFormData.companyCustomer = $ctrl.companyCustomer;
                openEditDataDialog($ctrl.customerFormData);

            });
        }

        function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {

            $ctrl.customerFormData = data;
            $ctrl.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
            $ctrl.customerFormData.companyCustomerId = $ctrl.companyCustomer.id;
            openEditDataDialog($ctrl.customerFormData);
        }

        function openEditDataDialog(customerFormData) {


            $ctrl.columnCount = 4;
            $mdDialog.show({
                locals: {dialogData: customerFormData, columnCount: $ctrl.columnCount},
                controller: ComponentIntakeDataDialogController,
                templateUrl: 'app/components/eyeson/intake-data-component/component-intake-data-dialog.html',
                controllerAs: '$ctrl',
                // parent: angular.element(document.body),
                targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });
        };

        function deleteCustomerFormData(formData) {

            DialogService.showConfirm("آیا از حذف اطلاعات مورد نظر اطمینان دارید؟").then(function () {
                CompanyCustomerCustom.companyCustomerFormData().delete({id: formData.id},
                    function () {
                        loadAll();
                    });

            });
        }


        function loadAllCustomerGroups() {


            CustomerGroupCustom.getCustomerGroupsByCurrentCompany().query().$promise.then(function (items) {

                $ctrl.customerGroups = items;
            });
        }

        function customerGroupChanged() {
            if ($ctrl.companyCustomer.customerGroup.id == 1) {
                $ctrl.companyCustomer.customerGroup = null;
            }
        }

        function initNewCustomerIntakeData() {
            CompanyCustomerCustom.getEmptyCompanyCustomerIntakeData().query().$promise.then(function (res) {

                if (res) {
                    $ctrl.companyCustomer.customerIntakeData = res;
                }

            });
        }

        function createUser() {
            if ($ctrl.companyCustomer && $ctrl.companyCustomer.id) {
                UserCustom.createUserByAdmin().save($ctrl.companyCustomer, function (result) {
                    loadAll();
                });
            }
        }

        ComponentIntakeDataDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', 'columnCount'];

        function ComponentIntakeDataDialogController($scope, $mdDialog, dialogData, columnCount) {

            var $ctrl2 = this;
            $ctrl2.customerFormData = dialogData;
            $ctrl2.columnCount = null;
            $ctrl2.columnCount = columnCount;
            $ctrl.sidebarStatus = localStorage.getItem("userFavoriteSideMenu");


            $ctrl2.save = function () {

                // $ctrl2.customerFormData.companyCustomerId = vm.companyCustomer.id;
                // $ctrl2.customerFormData.companyCustomer = vm.companyCustomer;

                $ctrl2.customerFormData.companyCustomer.formsData = null;
                // $ctrl2.customerFormData.companyCustomForm = $ctrl.companyCustomer.forms[0];
                if (!$ctrl2.customerFormData.intakeData) {

                    CompanyCustomerCustom.companyCustomerFormData().save($ctrl2.customerFormData, function (result) {
                        loadAll();
                    });

                } else {

                    CompanyCustomerCustom.companyCustomerFormData().update($ctrl2.customerFormData, function (result) {
                        loadAll();
                    });

                }

                $mdDialog.hide();

            };

            $ctrl2.cancel = function () {
                $mdDialog.cancel();
            };

            $ctrl2.getContainerClass = function () {
                if ($ctrl.sidebarStatus == 'close')
                    return 'container-wide';
                if ($ctrl.sidebarStatus == 'open')
                    return 'container-small';
            }


        }


        // $scope.$watch('$ctrl.companyCustomer',function(companyCustomer){
        //
        //     if($ctrl.mode=='NEW')
        //         return;
        //     if(companyCustomer && companyCustomer.id)
        //     {
        //         $ctrl.companyCustomer = companyCustomer;
        //         loadAll();
        //     }
        //
        // })


    }

    var CompanyCustomerComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/company-customer/partial-form.company-customer.html',
        controller: CompanyCustomerComponentController,
        bindings:
            {
                companyCustomer: '=',
                mode: "=",
                canSave: "=",
                isPopUp: "=?"
            }

    };

    angular
        .module('tikonApp')
        .component('pfCompanyCustomer', CompanyCustomerComponent)

    CompanyCustomerComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'CompanyCustomerCustom', '$mdDialog', 'DialogService', 'CustomerGroupCustom', 'UserCustom', 'CustomerCustom'];


})();

